import { AbstractControl, ValidatorFn } from '@angular/forms';
// import { dateOfBirthFormatter } from '../utils/format-dateOfBirth';

export function dateOfBirthValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        try {
            // Return error if user has manually entered an age under 18
            const today = new Date();
            const year = today.getFullYear();
            const month = today.getMonth();
            const day = today.getDate();
            const limit = new Date(year - 18, month, day)
            if (limit < control.value) return { invalidDateOfBirth: true }

            return control.value.getTime() === control.value.getTime() 
                ? null 
                : { invalidDateOfBirth: true };
        } catch { }
        return { invalidDateOfBirth: true };
    };
}